import ChildCard from "@shared-layouts/ChildCard";
import {
  TypographyH6,
  TypographyH5,
} from "@shared-ui-components/CustomTypography";
import { ErrorState } from "@src/constants";

import { Skeleton } from "@mui/material";
import {
  ChildCardColumnWrapper,
  ChildCardContentWrapper,
  ChildCardWrapper,
  TotalSalesSharedCardMainWrapper,
  TotalSalesSharedCardSubWrapper,
} from "./style";

interface listType {
  title?: string;
  value: string | undefined | null;
}

interface TotalSalesSharedCardProps {
  title: string;
  listData: Array<listType>;
  icon: JSX.Element;
  index: number;
  lastCard: number;
  loading: boolean;
}

const TotalSalesSharedCard = (props: TotalSalesSharedCardProps) => {
  const { title, listData, icon, index, lastCard, loading } = props;

  const getValue = (value: string | null | undefined) => {
    if (loading) return <Skeleton width="70%" />;
    if (value === null || value === undefined) return <ErrorState />;
    return <TypographyH5>{value}</TypographyH5>;
  };

  return (
    <TotalSalesSharedCardMainWrapper
      RemoveLeftPadding={index === 0}
      RemoveRightPadding={index === lastCard}
    >
      <TotalSalesSharedCardSubWrapper>
        <ChildCard title={title} icon={icon} disableDividerStyle>
          <ChildCardWrapper>
            {listData?.map((i: listType) => {
              return (
                <ChildCardColumnWrapper key={i?.title}>
                  <ChildCardContentWrapper>
                    <TypographyH6>{i?.title || ""}</TypographyH6>
                    {getValue(i?.value)}
                  </ChildCardContentWrapper>
                </ChildCardColumnWrapper>
              );
            })}
          </ChildCardWrapper>
        </ChildCard>
      </TotalSalesSharedCardSubWrapper>
    </TotalSalesSharedCardMainWrapper>
  );
};

export default TotalSalesSharedCard;
